import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { queryClient } from '../../../App'
import { getReports } from '../../../services/ApiService'
import NewPaginationStore from '../../../stores/NewPaginationStore'
import { getComp } from '../../../utils/utils/DI'
import { REPORT_KEYS } from '../../SingleRequestReport/consts/request-report.keys'
import {
  RequestReportsParamsType,
  RequestReportsResponse,
} from '../types/report.types'

const initParams: RequestReportsParamsType = {}

export const requestsReportsPaginationStore = new NewPaginationStore(initParams)

export const useGetReportTableData = () => {
  const {
    page,
    size,
    sort,
    params: {
      IsDealerSenderOnly,
      closeDateFrom,
      closeDateTo,
      creationDateFrom,
      creationDateTo,
      reportId,
      statuses,
      dealerIds,
      financialSourceIds,
      year,
      month,
    },
  } = requestsReportsPaginationStore

  const userId = getComp('UserInfoStore')?.info?.id

  return useQuery(
    {
      queryKey: [
        REPORT_KEYS.GET_REPORTS,
        size,
        page,
        sort,
        IsDealerSenderOnly,
        closeDateFrom,
        closeDateTo,
        creationDateFrom,
        creationDateTo,
        reportId,
        statuses,
        userId,
        dealerIds,
        financialSourceIds,
        year,
        month,
      ],
      queryFn: (): Promise<RequestReportsResponse> =>
        getReports({
          size,
          page,
          IsDealerSenderOnly,
          closeDateFrom,
          closeDateTo,
          creationDateFrom,
          creationDateTo,
          reportId,
          statuses,
          dealerIds,
          financialSourceIds,
          year,
          month,
          sort: sort ?? undefined,
        }),
      staleTime: 1000000,
      placeholderData: keepPreviousData,
      enabled: () => !!userId,
    },
    queryClient,
  )
}
